import {
  FETCH_NEWS_REQUEST,
  FETCH_NEWS_SUCCESS,
  FETCH_NEWS_FAILURE,
  FETCH_NEWS_DETAILS_REQUEST,
  FETCH_NEWS_DETAILS_SUCCESS,
  FETCH_NEWS_DETAILS_FAILURE,
} from "../actions/newsActions";

const initialState = {
  news: [],
  top_news: [],
  newsDetail: null,
  loading: false,
  error: null,
};

const newsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_NEWS_REQUEST:
    case FETCH_NEWS_DETAILS_REQUEST:
      return { ...state, loading: true };

    case FETCH_NEWS_SUCCESS:
      return {
        ...state,
        loading: false,
        news: action.payload.news,
        top_news: action.payload.top_news,
      };

    case FETCH_NEWS_DETAILS_SUCCESS:
      return { ...state, loading: false, newsDetail: action.payload };

    case FETCH_NEWS_FAILURE:
    case FETCH_NEWS_DETAILS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default newsReducer;
